import * as React from 'react';
import {
    UserOutlined,
    InstagramFilled,
    ShoppingCartOutlined,
    FacebookFilled,
    HeartFilled,
    SearchOutlined,
    LinkedinFilled,
    MenuFoldOutlined,
} from '@ant-design/icons';
import { Suspense, useEffect, useState } from 'react';
import '../../../shared/components/layout/custom.js';

import {
    Layout,
    Typography,
    Menu,
    Dropdown,
    Badge,
    Avatar,
    Row,
  Select,
    Image,
    Col,
    Spin,
    notification,
    Input,
    Space, Button,
} from 'antd';
import { useTranslation } from 'react-i18next';

import LoaderOverlay from 'shared/components/LoaderOverlay';

import './Layout.scss';
import { NavLink, Link, useHistory } from 'react-router-dom';
import { AuthConsumer } from '../../contexts/AuthContext';
import Parameters from '../../parameters';
import API_SERVICE from '../../services/api-service';
import { useMedia } from 'react-use';
import { getImageUrl } from '../../services/Utility';
import applyIcon from '../../../client/src/img/apply-icon.png';
import loginIconBlack from '../../../client/src/img/login-icon-black.png';
import loginIconWhite from '../../../client/src/img/login-icon-white.png';
import fbIcon from '../../../client/src/img/fb.png';
import linkedInIcon from '../../../client/src/img/linkedin.png';

const { Header, Content } = Layout;
const { Text } = Typography;

export default function DesktopLayout({ showMobileButton,
                                          children,
                                      }: any) {
    const { t,i18n } = useTranslation();
    const history = useHistory();
    const settings = JSON.parse(localStorage.getItem('settings') as string);
    const [categories, setCategories] = useState([] as any[]);
    const [search, setSearch] = useState('');
    const [lang, setLang] = useState('' as any);
    const isMobile = useMedia('(max-width: 611px)');
    const isTablet = useMedia('(max-width: 1011px)');

    const  currentLanguage = localStorage.getItem('language') || Parameters.DefaultLang
    useEffect(() => {
        API_SERVICE.fetchCategories({ per_page: 1000 }).then(({ data: { data: { items } } }) => {
            setCategories(items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        });

       console.log("pathname", showMobileButton);

        // let link = document.querySelector('link[rel~=\'icon\']');
        // if (!link) {
        //     link = document.createElement('link');
        //     // @ts-ignore
        //     link.rel = 'icon';
        //     document.getElementsByTagName('head')[0].appendChild(link);
        // }
        // // @ts-ignore
        // link.href = Parameters.ImageBaseUrl + settings.logo.slug + settings.logo.ext;
    }, []);

    const menu = (
        <Menu>
            {categories.map((c: any) => {
                return <Menu.Item>
                    <Link to={`/courses?categoryId=${c.id}`}>
                        {c.name}
                    </Link>
                </Menu.Item>;
            })}
        </Menu>
    );
    let theme = '';
    if (settings && settings.theme_config) {
        theme = JSON.parse(settings.theme_config).color;
    }

    return (
        <AuthConsumer>
            {({ isAuth, updateCart, cartTime, cart, user }) => (
                <Layout
                    style={{ minHeight: '100vh' }}
                    className={`desktop-layout`}>
                    <Header className='header-wrapper'>
                    <nav className="navbar navbar-expand-lg bg-white frontend-header navbar-light pl-sm-4 pr-sm-4">
                        {/* menubar on mobile view */}

                      {showMobileButton && (
                        <button
                            className="navbar-toggler d-block d-md-none"
                            id="mobileMenubar"
                            type="button"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        )}

                        <div className="navbar-brand ml-4">
                            <NavLink to={'/'}>
                                <Image
                                    preview={false}
                                    src={Parameters.ImageBaseUrl + settings.logo.slug + settings.logo.ext}
                                    style={{maxWidth:"150px"}} />
                            </NavLink>
                        </div>

                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="collapsibleNavbar">
                            <ul className="navbar-nav ml-5">
                            <li className="nav-item">
                                {
                                    user ? <></> 
                                    : 
                                    <>
                                    {/* <NavLink to={'/instructor-register'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 btn btn-golden btn-header text-111827">
                                            For Instructor
                                            <span>
                                                <img src={loginIconWhite} className="ml-2" style={{width:"11px"}} />
                                            </span>
                                    </NavLink> */}
                                    </>
                                }
                            </li>
                            </ul>
                            <ul className="navbar-nav ml-auto align-items-center">
                                <li className="nav-item">
                                    <NavLink to={'/'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 text-111827">
                                        
                                    {t('genDict.Home')}
                                    </NavLink>
                                </li>
                            {/* <li className="nav-item">
                                <NavLink to={'/my/management/all-courses'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 text-111827">
                                    
                                    Browse Courses
                                </NavLink>
                            </li> */}
                            {/* {user ?
                                <>
                                <li className="nav-item">
                                    <NavLink to={'/my/courses'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 text-111827">
                                        My Courses
                                    </NavLink>
                                </li>
                                </>
                                :<></>
                            } 
                            <li className='nav-item'>
                                <div className='pr-3 front-site-language-selector'>
                                    <Select className='form-control' value={currentLanguage} onChange={(e)=>{
                                    localStorage.setItem('language',e);
                                    i18n.changeLanguage(e);
                                    window.location.reload();
                                    }
                                    }
                                    style={{height: '36px'}}>
                                        <Select.Option value={'en'}>English</Select.Option>
                                        <Select.Option value={'de'}>German</Select.Option>
                                        <Select.Option value={'ar'}>Arabic</Select.Option>
                                    </Select>
                                </div>
                            </li>*/}
                            {user ?
                                <>
                                {/* <li className='nav-item'>
                                    <div className='custom-nav-link'>
                                        <FavouriteComponent isAuth={isAuth} />
                                    </div>
                                </li> */}
                            {/* {user?.role?.id === 4 ?<li className='nav-item'>
                                <div className='custom-nav-link'>
                                    <CartComponent cart={cart} updateCart={updateCart}
                                        cartTime={cartTime}
                                        isAuth={isAuth} />
                                </div>
                            </li>:""} */}
                                </>
                                :<></>
                            }
                            <li className="nav-item">
                                
                                {
                                    user ? <>
                                        <NavLink to={'/my/profile'} activeClassName='active-nav-link'>
                                            <div className='custom-nav-link account-details'>
                                                <Avatar size={30} src={getImageUrl(user.avatar)}
                                                        icon={<UserOutlined />} />
                                                <Text style={{ marginTop: '4px' }}>{user.name}</Text>
                                            </div>
                                        </NavLink>
                                    </> : <NavLink to={'/login'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 btn btn-default text-uppercase btn-header text-111827">
                                        {t('genDict.login')}
                                            <span>
                                                <img src={loginIconBlack} className="ml-2" style={{width:"13px"}} />
                                            </span>
                                    </NavLink>
                                }
                            </li>
                            <li className="nav-item">
                                {
                                    user ? <></> 
                                    : 
                                    <NavLink to={'/register'} activeClassName='active-nav-link' className="nav-link mr-md-4 mt-3 mt-md-0 btn btn-blue text-uppercase btn-header">
                                            Apply Now
                                            <span>
                                                <img src={applyIcon} className="ml-2" style={{width:"14px"}} />
                                            </span>
                                    </NavLink>
                                }
                            </li>
                            </ul>
                        </div>
                        </nav>
                        {/* <Row gutter={20} align={'middle'}>
                            <Col flex={'auto'}>
                                <Row gutter={20}>
                                    <Col>
                                        <div className='custom-nav-link'>
                                            <NavLink to={'/'}>
                                                <Image
                                                    preview={false}
                                                    className={'logo'}
                                                    src={Parameters.ImageBaseUrl + settings.logo.slug + settings.logo.ext} />
                                            </NavLink>
                                        </div>
                                    </Col>
                                    {
                                        !isMobile && <></>
                                    }
                                </Row>
                            </Col>

                            {
                                !isMobile ?
                                    <Col>
                                        <Row>
                                            {
                                                !isTablet && <Col>
                                                    <Input
                                                        className={'search-box'}
                                                        size={'large'}
                                                        onPressEnter={() => {
                                                            history.push(`/courses?search=${search}`);
                                                        }}
                                                        onChange={(e: any) => {
                                                            setSearch(e.target.value);
                                                        }}
                                                        style={{ width: '400px' }}
                                                        placeholder={t('genDict.search')}
                                                        suffix={<div className='search-icon-wrapper'><SearchOutlined />
                                                        </div>}
                                                    />
                                                </Col>
                                            }

                                            <Col>
                                                <Dropdown overlay={menu}>
                                                    <div className='custom-nav-link'>
                                                        {t('genDict.categories')}
                                                    </div>
                                                </Dropdown>
                                            </Col>

                                            <Col>
                                                <NavLink to={'/my/courses'} activeClassName='active-nav-link'>
                                                    <div className='custom-nav-link'>
                                                        {t('genDict.myCourses')}

                                                    </div>
                                                </NavLink>
                                            </Col>
                                            <Col>
                                                <div className='custom-nav-link'>
                                                    <FavouriteComponent isAuth={isAuth} />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className='custom-nav-link'>
                                                    <CartComponent cart={cart} updateCart={updateCart}
                                                                   cartTime={cartTime}
                                                                   isAuth={isAuth} />
                                                </div>
                                            </Col>
                                          <Col>
                                                <div className='custom-nav-link'>
                                                  <Select value={currentLanguage} onChange={(e)=>{
                                                    localStorage.setItem('language',e);
                                                    i18n.changeLanguage(e);
                                                    window.location.reload();
                                                  }
                                                  }>
                                                    <Select.Option value={'en'}>English</Select.Option>
                                                    <Select.Option value={'de'}>German</Select.Option>
                                                  </Select>
                                                </div>
                                            </Col>
                                            <Col>
                                                {
                                                    user ? <>
                                                        <NavLink to={'/my/profile'} activeClassName='active-nav-link'>
                                                            <div className='custom-nav-link account-details'>
                                                                <Avatar size={30} src={getImageUrl(user.avatar)}
                                                                        icon={<UserOutlined />} />
                                                                <Text style={{ marginTop: '4px' }}>{user.name}</Text>
                                                            </div>
                                                        </NavLink>
                                                    </> : <NavLink to={'/login'} activeClassName='active-nav-link'>
                                                        <div className='custom-nav-link'>
                                                            {t('genDict.login')}
                                                        </div>
                                                    </NavLink>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    : <Col>
                                        <Button type='default' size={'large'}>
                                            <MenuFoldOutlined />
                                        </Button>
                                    </Col>
                            }
                        </Row> */}
                    </Header>
                    <Content className={'content-layout'}>
                        <Suspense fallback={<LoaderOverlay size='large' loading={true} />}>
                            {children}
                        </Suspense>
                    </Content>
                    {!user ?
                    <div className="container-fluid bg-white plr-4rem pt-5 pb-5 footer-callout">
                        <div className="row footer-callout-row">
                            <div className="col-md-6 mt-4">
                                <div className="user-reg light-shadow p-3 p-sm-4 p-md-5">
                                    <h3 className="mb-5">Become a Instructor.</h3>
                                    <NavLink to={'/instructor-register'} activeClassName='active-nav-link' className="btn btn-blue">
                                            Apply Now
                                            <span>
                                                <img src={applyIcon} className="ml-2" style={{width:"14px"}} />
                                            </span>
                                    </NavLink>
                                </div>
                            </div>
                            <div className="col-md-6 mt-4">
                                <div className="user-reg pos-relative light-shadow p-3 p-sm-4 p-md-5">
                                    <div className="apply-overlay"></div>
                                    <div className="pos-relative" style={{zIndex: "1"}}>
                                        <h3 className="mb-5">Become a Student.</h3>
                                        <NavLink to={'/register'} activeClassName='active-nav-link' className="btn btn-apply-student">
                                            Apply Now
                                            <span>
                                                <img src={applyIcon} className="ml-2" style={{width:"14px"}} />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :<></>
                    }
                    <div className="container-fluid bg-white plr-4rem pt-3 pb-3 bg-black footer">
                    {/* <div className="container-fluid bg-white plr-4rem pt-5 pb-5 bg-black footer"> */}
                    {/* {!user ?<div className="mt-md-5 mb-md-5 pt-md-4 pb-md-4"></div>:<></>} */}
                        {/* <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-6 mt-4">
                                <h3 className="mb-3 text-uppercase text-white">velearn</h3>
                                <p className="mb-2 text-white max-width-450">Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen Sylter Deich. </p>
                            </div>
                            <div className="col-lg-4 col-md-5 col-sm-6 mt-4 text-center">
                                <p className="mb-3 text-white text-uppercase">Subscribe to our newsletter</p>
                                <div className="input-group mb-3">
                                <input type="email" className="form-control" placeholder="Enter email address" style={{height:"43px"}}/>
                                <div className="input-group-append">
                                    <button className="btn btn-blue text-uppercase" type="submit" style={{border:"3px solid #fff!important"}}>subscribe</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="row plr-12">
                            <div className="col-lg-4 col-md-4 col-sm-6 mt-3">
                                <h5 className="text-uppercase text-white">categories</h5>
                                <ul className="footer-ul">
                                    <li>
                                        <a href="#" className="text-white text-capitalize">All Courses</a>
                                    </li>
                                    <li>
                                        <a href="#" className="text-white">Marketing Courses</a>
                                    </li>
                                    <li>
                                        <a href="#" className="text-white">Design Courses</a>
                                    </li>
                                    <li>
                                        <a href="#" className="text-white">Web Development courses</a>
                                    </li>
                                    <li>
                                        <a href="#" className="text-white">bookkeeping & accounting</a>
                                    </li>
                                    <li>
                                        <a href="#" className="text-white">project management courses</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-6 mt-3">
                                <div>
                                    <h5 className="text-uppercase text-white">our company</h5>
                                    <ul className="footer-ul">
                                        <li>
                                            <a href="#" className="text-white text-capitalize">About Us</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">career with us</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">badge achievement system</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">our success stories</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">student success stories</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-6 mt-3">
                                <div>
                                    <h5 className="text-uppercase text-white">support</h5>
                                    <ul className="footer-ul">
                                        <li>
                                            <a href="#" className="text-white text-capitalize">contact with us</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">system requirement</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">terms & conditions</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">privacy policy</a>
                                        </li>
                                        <li>
                                            <a href="#" className="text-white">cookies policy</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr/> */}
                        <div className="row">
                            {/* <div className="col-lg-4 col-md-6 mt-3">
                                <ul className="footer-social-media-ul">
                                    <li>
                                        <a href="#">
                                            <img src={fbIcon} className="footer-social-media"/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <img src={linkedInIcon} className="footer-social-media"/>
                                        </a>
                                    </li>
                                </ul>
                            </div> */}
                            <div className="col-lg-12 col-md-12 text-center">
                                {/* <p className="mb-0 text-white">© 2023 Railtel Education Inc., All rights reserved</p> */}
                                <p className="mb-0 text-white">{t('genDict.Footer')}</p>
                            </div>
                            {/* <div className="col-lg-4 col-md-12 mt-3">
                            {!user ?
                                <ul className="footer-login-apply">
                                    <li className="nav-item">
                                        <NavLink to={'/login'} activeClassName='active-nav-link' className="nav-link mr-4 mt-3 mt-md-0 btn btn-default text-uppercase btn-header text-111827">
                                            {t('genDict.login')}
                                                <span>
                                                    <img src={loginIconBlack} className="ml-2" style={{width:"11px"}} />
                                                </span>
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to={'/register'} activeClassName='active-nav-link' className="nav-link mt-3 mt-md-0 btn btn-blue text-uppercase btn-header" style={{border: "1px solid #4f46e5!important"}}>
                                            Apply Now
                                            <span>
                                                <img src={applyIcon} className="ml-2" style={{width:"14px"}} />
                                            </span>
                                        </NavLink>
                                    </li>
                                </ul>
                                :<></>
                             }
                            </div> */}
                        </div>
                    </div>
                    {/* <div className='footer-wrapper'>
                        <Row gutter={20} className={'secondary-footer'}>
                            {
                                isMobile ?
                                    <>shs
                                        <Col xs={24}>
                                            <NavLink
                                                to={'/pages/copyright'}><Text>{t('genDict.copyRight')}</Text></NavLink>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text><InstagramFilled /></Text></a>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text> <FacebookFilled /></Text></a>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text> <LinkedinFilled /></Text></a>
                                        </Col>
                                        <Col xs={24}>
                                            <NavLink to={'/pages/about'}><Text>{t('genDict.about')}</Text></NavLink>
                                        </Col>
                                        <Col xs={24}>
                                            <NavLink to={'/pages/contact'}><Text>{t('genDict.contact')}</Text></NavLink>
                                        </Col>
                                        <Col xs={24}>
                                            <NavLink
                                                to={'/pages/terms-of-use'}><Text>{t('genDict.termsOfUse')}</Text></NavLink>
                                        </Col>
                                        <Col xs={24}>
                                            <NavLink
                                                to={'/pages/privacy-policy'}><Text>{t('genDict.privacyPolicy')}</Text></NavLink>
                                        </Col>
                                    </> :
                                    <>
                                        <Col flex={'auto'}>
                                            <NavLink
                                                to={'/pages/copyright'}><Text>{t('genDict.copyRight')}</Text></NavLink>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text><InstagramFilled /></Text></a>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text> <FacebookFilled /></Text></a>
                                        </Col>
                                        <Col>
                                            <a target={'_blank'} href={'about-us'}><Text> <LinkedinFilled /></Text></a>
                                        </Col>
                                        <Col>
                                            <NavLink to={'/pages/about'}><Text>{t('genDict.about')}</Text></NavLink>
                                        </Col>
                                        <Col>
                                            <NavLink to={'/pages/contact'}><Text>{t('genDict.contact')}</Text></NavLink>
                                        </Col>
                                        <Col>
                                            <NavLink
                                                to={'/pages/terms-of-use'}><Text>{t('genDict.termsOfUse')}</Text></NavLink>
                                        </Col>
                                        <Col>
                                            <NavLink
                                                to={'/pages/privacy-policy'}><Text>{t('genDict.privacyPolicy')}</Text></NavLink>
                                        </Col>
                                    </>
                            }
                        </Row>
                    </div> */}
                </Layout>
            )
            }
        </AuthConsumer>
    );
}

function CartComponent({
                           cart,
                       }: any) {
    const cartCount = cart.length;
    return (
        <NavLink to={'/my/cart'} activeClassName='active-nav-link'>
            <Badge count={cartCount === -1 ? <Spin /> : cartCount}>
                <ShoppingCartOutlined />
            </Badge>
        </NavLink>
    );
}

function FavouriteComponent({}: any) {
    return (
        <NavLink to={'/my/favourites/courses'} activeClassName='active-nav-link'>
            <HeartFilled />
        </NavLink>
    );
}
